import type { WeeklyReportAbsenceType } from "../api/client";
import { ABSENCE_TYPE_LABEL } from "./absenceMeta";

/**
 * Подписи типов отсутствий для отчётных вьюх (Недельный/Месячный свод,
 * Исключения). Базовые типы берутся из absenceMeta (единый источник для
 * форм и отчётов), `other` — catch-all бэкенда для неизвестных типов.
 *
 * До рефакторинга этот словарь был скопирован в 3 компонентах — при
 * добавлении нового типа отсутствия приходилось править все копии.
 */
export const REPORT_ABSENCE_TYPE_LABEL: Record<WeeklyReportAbsenceType, string> = {
  ...ABSENCE_TYPE_LABEL,
  other: "Другое",
};

interface EmployeeRowRef {
  employee: { id: number; full_name: string };
}

/**
 * Опции дропдауна «Сотрудник» из строк отчёта: value = id, label = ФИО,
 * сортировка по алфавиту. Используется всеми тремя отчётными вьюхами.
 */
export function employeeOptionsFromRows(
  rows: EmployeeRowRef[],
): { value: string; label: string }[] {
  return rows
    .map((r) => ({ value: String(r.employee.id), label: r.employee.full_name }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
